import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasTickets from './subabasTickets';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloDaf } from '../../../../services/enum/useModuloDaf';
import { useStatusTicket } from '../../../../services/enum/useStatusTicket';
import { useTipoTicket } from '../../../../services/enum/useTipoTicket';
import { getTicket } from '../../../../services/gestaoSisAF/ticketsService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { getUserPapelAtivo } from '../../../../services/usuario/userService';
import {
  formataNomeMeioSiglas,
  formatDateSimp,
} from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';
import { versaoAtualSisaf } from '../../AppDAF/versaoSisaf';

export default function TicketFicha() {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const navigate = useNavigate();

  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const moduloSisaf = useModuloDaf();
  const tipoTicket = useTipoTicket();
  const statusTicket = useStatusTicket();

  const [papelUsuario, setPapelUsuario] = useState('');

  useEffect(() => {
    async function fetchPapel() {
      try {
        const { papelUsuario } = await getUserPapelAtivo(userID);
        setPapelUsuario(papelUsuario);
      } catch (err) {
        console.error(err);
      }
    }

    fetchPapel();
  }, [userID]);

  const responsavelRetorno = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Ângelo Morais' },
    { value: 2, label: 'Allan Ribeiro' },
    { value: 3, label: 'Jackson Ramos' },
    { value: 4, label: 'Mateus Farias' },
    { value: 99, label: 'Outro' },
  ];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formMain, setFormMain] = useState({
    usuarioId: userID,
    interfaceSisAf: '',
    moduloSisAf: '',
    tipoTicket: '',
    statusTicket: '',
    mensagemUsuario: '',
    dataRetorno: '',
    dataInicio: '',
    retornoDevs: '',
    responsavelDev: '',
    versaoSisaf: '',
    observacoes: '',
    responsavelRetornoOption: 0,
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registro = await getTicket(id);
      setLogData(registro);

      const dataRetorno = registro.dataRetorno
        ? new Date(registro.dataRetorno).toISOString().split('T')[0]
        : '';

      const dataInicioAnalise = registro.dataInicio
        ? new Date(registro.dataInicio).toISOString().split('T')[0]
        : '';

      const responsavelRetornoOption = responsavelRetorno.find(
        (option) => option.label === registro.responsavelDev,
      ) || { value: 0, label: 'Não informado' };

      setFormMain({
        usuarioId: userID,
        interfaceSisAf: registro.interfaceSisAf,
        moduloSisAf: registro.moduloSisAf,
        tipoTicket: registro.tipoTicket,
        statusTicket: registro.statusTicket,
        mensagemUsuario: registro.mensagemUsuario,
        dataRetorno: dataRetorno,
        dataInicio: dataInicioAnalise,
        retornoDevs: registro.retornoDevs,
        responsavelDev: registro.responsavelDev,
        versaoSisaf: registro.versaoSisaf,
        observacoes: registro.observacoes,
        responsavelRetornoOption: responsavelRetornoOption.value, // Configura o valor do responsavelRetornoOption
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //
  const [statusTicketStyle, setStatusTicketStyle] =
    useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';
    const branco = 'white';

    const status = Number(formMain.statusTicket);

    const newStatusStyle = {
      backgroundColor:
        status === 0
          ? branco
          : status === 1
            ? vermelho
            : status === 2
              ? amarelo
              : verde,
    };

    setStatusTicketStyle(newStatusStyle);
  }, [formMain.statusTicket]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasTickets(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/maisopcoes/tickets/ficha/dadosgerais`,
      },
    ];
  }

  const [isStatusReadOnly, setIsStatusReadOnly] = useState(false);
  useEffect(() => {
    if (formMain.statusTicket == '2') {
      setIsStatusReadOnly(false);
    } else if (formMain.statusTicket == '1' || formMain.statusTicket == '') {
      setIsStatusReadOnly(true);
      setFormMain((prev) => ({
        ...prev,
        dataInicioAnalise: '',
        dataRetorno: '',
        responsavelDev: '',
        responsavelRetornoOption: 0,
      }));
    }
  }, [formMain.statusTicket]);

  const [isRetornoReadOnly, setIsRetornoReadOnly] = useState(false);
  useEffect(() => {
    if (formMain.statusTicket == '3') {
      setIsRetornoReadOnly(false);
    } else {
      setIsRetornoReadOnly(true);
      setFormMain((prev) => ({
        ...prev,
        dataRetorno: '',
      }));
    }
  }, [formMain.statusTicket]);

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    if (name === 'responsavelRetornoOption') {
      const selectedOption = responsavelRetorno.find(
        (option) => option.value === Number(value),
      );
      setFormMain((prevState) => ({
        ...prevState,
        responsavelDev: selectedOption ? selectedOption.label : '',
        responsavelRetornoOption: Number(value),
      }));
    } else {
      setFormMain((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.moduloSisAf) {
      errors.push('<b>Módulo SisAF</b> é obrigatório.');
    }

    if (!form.tipoTicket) {
      errors.push('<b>Tipo de Ticket</b> é obrigatório.');
    }

    if (!form.mensagemUsuario) {
      errors.push('<b>Mensagem</b> é obrigatória.');
    }
    if (form.statusTicket === 3) {
      if (!form.retornoDevs) {
        errors.push('<b>Mensagem de Retorno dos Devs</b> é obrigatória.');
      }

      if (!form.dataRetorno) {
        errors.push('<b>Data do retorno</b> é obrigatório.');
      }

      if (!form.responsavelRetornoOption) {
        errors.push('<b>Responsável pelo Retorno</b> é obrigatório.');
      }
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formMain);
      if (!isFormValid) return;

      let statusDoTicket = formMain.statusTicket;
      if (statusDoTicket === '') {
        statusDoTicket = '1';
      }

      const formToSend = {
        ...formMain,
        interfaceSisAf: 1,
        moduloSisAf: Number(formMain.moduloSisAf),
        tipoTicket: Number(formMain.tipoTicket),
        statusTicket: Number(statusDoTicket),
        dataRetorno: formMain.dataRetorno ? formMain.dataRetorno : null,
        dataInicio: formMain.dataInicio ? formMain.dataInicio : null,
        versaoSisaf: versaoAtualSisaf.interfaceDAF,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/tickets/`, formToSend);

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/tickets/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formMain);
      if (!isFormValid) return;

      const formToSend = {
        ...formMain,
        interfaceSisAf: 1,
        moduloSisAf: Number(formMain.moduloSisAf),
        tipoTicket: Number(formMain.tipoTicket),
        statusTicket: Number(formMain.statusTicket),
        dataRetorno: formMain.dataRetorno ? formMain.dataRetorno : null,
        dataInicio: formMain.dataInicio ? formMain.dataInicio : null,
      };

      const response = await httpClient.patch(
        `/api/tickets/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/tickets/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/tickets');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/maisopcoes/tickets"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} entity="TB_TICKET" id={Number(fichaID)} />

          <BoxConteudo boxTitulo="Mensagem do usuário">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="250px">
                <SelectInput
                  name="moduloSisAf"
                  options={moduloSisaf}
                  label="Módulo SisAF"
                  value={formMain.moduloSisAf}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="tipoTicket"
                  options={tipoTicket}
                  label="Tipo de Ticket"
                  value={formMain.tipoTicket}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="usuario"
                  label="Usuário"
                  value={logData.usuarioRegistro.nomeCompleto}
                  id="usuario"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataRegistro"
                  label="Data da Mensagem"
                  value={
                    logData.dataRegistro
                      ? formatDateSimp(logData.dataRegistro)
                      : ''
                  }
                  id="dataRegistro"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="140px">
                <Input
                  name="versaoSisaf"
                  label="Versão Sisaf"
                  value={
                    formMain.versaoSisaf
                      ? formMain.versaoSisaf
                      : versaoAtualSisaf.interfaceDAF
                  }
                  id="usuario"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            {/* Descrição */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="mensagemUsuario"
                  label="Mensagem"
                  value={formMain.mensagemUsuario}
                  id="mensagemUsuario"
                  onChange={handleChange}
                  type="textarea"
                  linhas={5}
                  required
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Retorno Devs">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusTicket"
                  options={statusTicket}
                  label="Status"
                  value={formMain.statusTicket}
                  onChange={handleChange}
                  style={statusTicketStyle}
                  disabled={papelUsuario !== '1'}
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="responsavelRetornoOption"
                  options={responsavelRetorno}
                  label="Responsável"
                  value={formMain.responsavelRetornoOption}
                  onChange={handleChange}
                  disabled={
                    papelUsuario !== '1' ||
                    (isStatusReadOnly && isRetornoReadOnly)
                  }
                />
              </CustomCol>

              <CustomCol width="200px">
                <Input
                  name="dataInicio"
                  label="Data de Início da Análise"
                  value={formMain.dataInicio}
                  id="dataInicio"
                  onChange={handleChange}
                  type="date"
                  readonly={
                    papelUsuario !== '1' ||
                    (isStatusReadOnly && isRetornoReadOnly)
                  }
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataRetorno"
                  label="Data do Retorno"
                  value={formMain.dataRetorno}
                  id="dataRetorno"
                  onChange={handleChange}
                  type="date"
                  readonly={papelUsuario !== '1' || isRetornoReadOnly}
                />
              </CustomCol>
            </CustomRow>

            {/* Descrição */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="retornoDevs"
                  label="Mensagem"
                  value={formMain.retornoDevs}
                  id="retornoDevs"
                  onChange={handleChange}
                  type="textarea"
                  linhas={5}
                  readonly={papelUsuario !== '1'}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formMain.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                  readonly={papelUsuario !== '1'}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
